import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Button,
    message,
    ProTableOt,
    useProTableOt,
    setParamsFilter,
    Popconfirm
} from "../../ui/ot";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs"
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from '../../ui/card'
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import useWindowSize from '../../online_public_catalog_query_construction/controllers/window_size';
import { useTranslation } from "react-i18next";
import { Calendar } from "lucide-react"
import { Badge } from "../../ui/badge"

const CurrentlyReserved = ({
    keyPrefix = "library.personal_study",

}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const actionRef = useRef();
    const columns = [
        {
            title: t(`book_title`),
            dataIndex: 'bib_title',
            key: 'bib_title',
        },
        {
            title: t(`book_title`),
            dataIndex: 'bib_subtitle',
            key: 'bib_subtitle',
        },
        {
            title: t(`overdue_status`),
            dataIndex: 'issue_days_due_status',
            key: 'issue_days_due_status',
        },
        {
            title: t(`author_name`),
            dataIndex: 'bib_author',
            key: 'bib_author',
        },
    ];
    const showCard = {
        xxl: 4,
        xl: 3,
        lg: 3,
        md: 2,
        sm: 2,
        xs: 1,
    }
    // 螢幕大小斷點判斷
    function getBreakpoint(width) {
        const breakpoints = {
            xxl: 1600,
            xl: 1200,
            lg: 992,
            md: 768,
            sm: 576,
            xs: 0,
        };
        if (width >= breakpoints.xxl) return 'xxl';
        if (width >= breakpoints.xl) return 'xl';
        if (width >= breakpoints.lg) return 'lg';
        if (width >= breakpoints.md) return 'md';
        if (width >= breakpoints.sm) return 'sm';
        return 'xs';
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "delete") {
                message.success(t('cancel_success'))
                actionRef.current.reloadAndRest();
            }
        }
        else if (status === "error") {
            if (axiosMode === "delete") {
                message.error(t('cancel_failure'))
            }
        }
    }
    //取得螢幕大小
    const { width, height } = useWindowSize();
    const HoldSelfController = useCRUDController({
        apiRoute: "/library/koha/hold/self",
    })
    const HoldController = useCRUDController({
        apiRoute: "/koha/hold",
        onFinish: onFinish
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    useEffect(() => {
        checkAll();
    }, []);
    return (<Row gutter={[16, 0]}>
        <Col span={24}>
            <ProTableOt
                check={check}
                setCheck={setCheck}
                reloadButton={false}
                manageColumnsButton={false}
                showSearch={true}
                readonly={true}
                actionRef={actionRef}
                showMode="card"
                headerTitle={
                    <>

                    </>
                }
                columns={columns}
                rowKey={'item_itemnumber'}
                toolBarRender={() => {
                    return [
                    ]
                }}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params,
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    return HoldSelfController.getData(newParams)
                }}
                cardModeSetting={{
                    columnsCount: showCard[getBreakpoint(width)],
                    singleRowHeight: "320px",
                }}
                cardRender={(item, { PatchButton, DeleteButton }) => {
                    return (
                        <Card key={item?.id} className="overflow-hidden border-[#e8e0d8] bg-white">
                            <CardHeader className="p-4">
                                <div className="flex justify-between items-start">
                                    <div className="space-y-1">
                                        <CardTitle className="line-clamp-1">{item?.bib_title}</CardTitle>
                                        <CardDescription>{item?.bib_author}</CardDescription>
                                    </div>
                                    <Badge variant="secondary" className="bg-[#f0e6da] text-[#e8a05c] hover:bg-[#f0e6da]">
                                        {t('reserved')}
                                    </Badge>
                                </div>
                            </CardHeader>
                            <CardContent className="p-4 pt-0">
                                <div className="flex gap-4">
                                    <div className="shrink-0">
                                        <img
                                            src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                                item?.bibitem_isbn}
                                            alt={item?.bib_title}
                                            className="h-[120px] w-[80px] rounded-md object-cover"
                                        />
                                    </div>
                                    <div className="flex flex-col justify-between">
                                        <div className="space-y-1">
                                            <div className="flex items-center text-sm">
                                                <Calendar className="mr-1 h-4 w-4 text-muted-foreground" />
                                                <span>{t('reservation_date')}: {new Date(item?.reserve_reservedate).toLocaleDateString("zh-TW")}</span>
                                            </div>
                                            <div className="text-sm text-muted-foreground">{t('item_barcode')}:{item?.item_barcode}</div>
                                            <div className="text-sm text-muted-foreground">{t('status_waiting_available')}:{!!item?.reserve_found_name ? item?.reserve_found_name : t('waiting_for_availability')}</div>
                                            <div className="text-sm text-muted-foreground">{t('pickup_branch')}:  <Badge variant="secondary" >
                                                {item?.reserve_branchname}
                                            </Badge>  </div>
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                            <CardFooter className="p-4 pt-0">
                                <Popconfirm
                                    title={t('cancel_reservation')}
                                    description={t('confirm_cancel_reservation')}
                                    onConfirm={() => {
                                        HoldController.deleteData([
                                            {
                                                reserve_id: item?.reserve_id
                                            }
                                        ])
                                    }}
                                >
                                    <Button
                                        variant="outline"
                                        className="w-full border-[#e8e0d8] text-[#e8a05c] hover:bg-[#f0e6da] hover:text-[#e8a05c]"
                                    >
                                        {t('cancel_reservation')}
                                    </Button>
                                </Popconfirm>
                            </CardFooter>
                        </Card>
                    )
                }}
                rowSelection={false}
                propsPatch={false}
                propsDelete={false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
            />
        </Col>
    </Row>)
}

export default CurrentlyReserved

